import axios from "axios";
import { MessageBox } from "element-ui";
import { getToken, removeToken, removeImToken } from "@/utils/cookies";
import { apiUrl } from "@/config/env";
import i18n from "@/i18n/config";

export const api = axios.create({
	baseURL: apiUrl,
	timeout: 30000,
});

api.interceptors.request.use(
	(config) => {
		const token = getToken();
		if (token) config.headers.Authorization = "Bearer " + token;
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

api.interceptors.response.use(
	(response) => {
		if (response.data.status === 0) {
			return Promise.reject(response.data.message);
		}
		return response.data;
	},
	(error) => {
		if (error.response.status === 401 || error.response.data.message === "Unauthenticated.") {
			removeToken();
			removeImToken();
			MessageBox.alert(i18n.t("apiJS.loginHasExpired"), i18n.t("apiJS.hint"), {
				confirmButtonText: i18n.t("common.sure"),
				type: "warning",
			}).then(() => {
				location.reload();
			});
		} else if (error.response.data.message) {
			return Promise.reject(error.response.data.message);
		} else {
			return Promise.reject(i18n.t("apiJS.unknownMistake"));
		}
	}
);

// 登录
export const login = (username, password, loginType) => {
	return api.post(
		"/auth/login",
		{ username: username, password: password, login_type: loginType },
		{
			headers: {
				accept: "application/x.sjlink.V2+json",
			},
		}
	);
};

// 更新备注
export const updateNote = (objectId, note) => {
	return api.post("/user/updateNote", {
		object_id: objectId,
		note: note,
	});
};

// 获取sales
export const getSales = () => {
	return api.get("/staff/getOtherStaff");
};

// 获取未读消息数
export const getUnreadCount = () => {
	return api.get("/message/getUnreadCount");
};

// 获取员工信息
export const getStaffInfo = () => {
	return api.get("/staff/getStaffInfo");
};

// 获取客户列表
export const getCustomers = () => {
	return api.get("/customer/getCustomers");
};

// 绑定客户电话号码
export const bindPhone = (customerId, phoneNumber, comment) => {
	return api.post("/customer/bindPhone", {
		customer_id: customerId,
		phone_number: phoneNumber,
		comment: comment,
	});
};

// 解除绑定客户电话号码
export const unbindPhone = (customerId, phoneNumber) => {
	return api.post("/customer/unbindPhone", {
		customer_id: customerId,
		phone_number: phoneNumber,
	});
};

// 编辑绑定客户电话号码
export const editPhone = (customerId, phoneNumber, comment) => {
	return api.post("/customer/editPhone", {
		customer_id: customerId,
		phone_number: phoneNumber,
		comment: comment,
	});
};

// 上传头像
export const updateAvatar = (avatarData) => {
	return api.post("/user/uploadAvatar", { avatar: avatarData });
};

// 获取base64头像
export const getBase64Avatar = (avatar) => {
	const params = {
		avatar: avatar,
	};

	return api.get("/user/getBase64Avatar", { params: params });
};
